import { useEffect, useState, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";

// Components
import { Navbar } from "@/components/Navbar";
import { Landing } from "@/pages/Landing";
import { Feed } from "@/pages/Feed";
import { Upload } from "@/pages/Upload";
import { Explore } from "@/pages/Explore";
import { GlobeView } from "@/pages/GlobeView";
import { Profile } from "@/pages/Profile";
import { PostDetail } from "@/pages/PostDetail";
import { AuthCallback } from "@/components/AuthCallback";
import { ProtectedRoute } from "@/components/ProtectedRoute";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth context
import { AuthProvider, useAuth } from "@/context/AuthContext";

// Hide loading screen once app is ready
const hideLoadingScreen = () => {
  // Give users a moment to appreciate the fullscreen window image
  setTimeout(() => {
    const loadingScreen = document.getElementById('loading-screen');
    if (loadingScreen) {
      loadingScreen.classList.add('fade-out');
      setTimeout(() => {
        loadingScreen.style.display = 'none';
      }, 800);
    }
  }, 2000); // Show loading screen for 2 seconds
};

function AppRouter() {
  const location = useLocation();
  
  // Hide loading screen after first render
  useEffect(() => {
    hideLoadingScreen();
  }, []);
  
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check for session_id in URL fragment BEFORE rendering routes (prevents race condition)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/feed" element={
        <ProtectedRoute>
          <Feed />
        </ProtectedRoute>
      } />
      <Route path="/upload" element={
        <ProtectedRoute>
          <Upload />
        </ProtectedRoute>
      } />
      <Route path="/explore" element={<Explore />} />
      <Route path="/globe" element={<GlobeView />} />
      <Route path="/profile/:userId" element={<Profile />} />
      <Route path="/post/:postId" element={<PostDetail />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="mood-lighting min-h-screen">
          <div className="noise-overlay" />
          <Navbar />
          <main className="pt-16">
            <AppRouter />
          </main>
          <Toaster position="bottom-right" theme="dark" />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
